import type { Opportunity } from "@entities";
import { Autocomplete, Button, Stack, TextField, Typography } from "@mui/material";
import { FormSection, LinkedRow } from "./partner-organization-form-ui";

type Props = {
  opportunitySearch: string;
  onOpportunitySearchChange: (value: string) => void;
  opportunityOptions: Opportunity[];
  selectedOpportunity: Opportunity | null;
  onSelectedOpportunityChange: (opportunity: Opportunity | null) => void;
  onLinkOpportunity: () => void;
  linkedOpportunities: Opportunity[];
  onUnlinkOpportunity: (opportunity: Opportunity) => void;
};

export function PartnerOrganizationOpportunitiesPanel({
  opportunitySearch,
  onOpportunitySearchChange,
  opportunityOptions,
  selectedOpportunity,
  onSelectedOpportunityChange,
  onLinkOpportunity,
  linkedOpportunities,
  onUnlinkOpportunity,
}: Props) {
  return (
    <FormSection
      title="התנדבויות מקושרות"
      description="שייכו משימות על לארגון כדי שיופיעו אצלו באפליקציה ובטבלה."
    >
      <Stack gap={2}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          gap={1.5}
          alignItems="flex-start"
        >
          <Autocomplete
            sx={{ flex: 1, width: "100%" }}
            options={opportunityOptions}
            value={selectedOpportunity}
            onChange={(_, opportunity) =>
              onSelectedOpportunityChange(opportunity)
            }
            inputValue={opportunitySearch}
            onInputChange={(_, value) => onOpportunitySearchChange(value)}
            getOptionLabel={(opportunity) => opportunity.title || opportunity.id}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            noOptionsText="הקלד לפחות 2 תווים לחיפוש"
            renderInput={(params) => (
              <TextField {...params} label="חיפוש משימה" />
            )}
          />
          <Button
            variant="contained"
            disabled={!selectedOpportunity}
            onClick={onLinkOpportunity}
            sx={{
              whiteSpace: "nowrap",
              textTransform: "none",
              height: 56,
              px: 2.5,
              borderRadius: 2,
            }}
          >
            קשר משימה
          </Button>
        </Stack>

        {linkedOpportunities.length === 0 ? (
          <Typography color="text.secondary" sx={{ fontSize: 14 }}>
            אין משימות מקושרות
          </Typography>
        ) : (
          linkedOpportunities.map((opportunity) => (
            <LinkedRow
              key={opportunity.id}
              primary={opportunity.title}
              onRemove={() => onUnlinkOpportunity(opportunity)}
              removeLabel="הסר קישור"
            />
          ))
        )}
      </Stack>
    </FormSection>
  );
}
